import type { Dispatch, SetStateAction } from 'react';

import { cn } from '@repo/lib/cn';

import { SearchInput } from '@/components/ui/input';

interface GroupsHeaderProps {
  onSearchChange: Dispatch<SetStateAction<string>>;
}

export default function GroupsHeader(groupsHeaderProps: GroupsHeaderProps) {
  const { onSearchChange } = groupsHeaderProps;

  return (
    <div className={cn('border-border-primary bg-background grid w-full grid-cols-3 grid-rows-1 gap-3 rounded-2xl border p-4')}>
      <h2 className={'text-foreground self-center text-xl font-semibold'}>Grupy</h2>
      <div className={'col-[1/4] row-[2/2] sm:col-[2/span_2] sm:justify-self-end'}>
        <SearchInput className="w-full grow sm:ms-auto sm:max-w-64" setValue={onSearchChange} placeholder={'Szukaj...'} />
      </div>
    </div>
  );
}
